import { render } from "./BurnCalendar.vue?vue&type=template&id=4746dff8"
import script from "./BurnCalendar.vue?vue&type=script&lang=ts"
export * from "./BurnCalendar.vue?vue&type=script&lang=ts"

import "./BurnCalendar.vue?vue&type=style&index=0&id=4746dff8&lang=scss"
script.render = render

export default script